import { render } from "./Page2D.vue?vue&type=template&id=22debb3f&scoped=true"
import script from "./Page2D.vue?vue&type=script&lang=js"
export * from "./Page2D.vue?vue&type=script&lang=js"

import "./Page2D.vue?vue&type=style&index=0&id=22debb3f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22debb3f"]])

export default __exports__